import { PodcastCardSlider } from "./PodcastCardSlider";

export default PodcastCardSlider;
